"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Labels = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Labels = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentShade: {
      dealLabel,
      ppaLabel,
      productCode
    }
  } = (0, _internal.useProduct)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LabelsRoot, {
    "data-testid": getTestId(_constants.LABELS),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.DealLabel, {
      label: dealLabel?.title,
      type: dealLabel?.labelKey,
      productCode: productCode,
      size: "small"
    }), ppaLabel?.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(`${_presentationComponents.PPA_LABEL}-${productCode}`),
      label: ppaLabel.title,
      color: "default",
      variant: "tag",
      size: "small"
    }) : null]
  });
};
exports.Labels = Labels;